import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Outlet wrapper that only lets `role === 'admin'` users through.
 * Sellers get redirected to the admin dashboard with a hint via toast (handled
 * elsewhere if needed). For now we simply route them home.
 */
export default function AdminOnlyRoute() {
  const { user, checking, isAdmin } = useAuth();
  if (checking) return null;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!isAdmin) return <Navigate to="/admin" replace />;
  return <Outlet />;
}
